import { Card, Col, Progress, Row } from 'antd'
import { BoosterMilestoneCompletion } from 'Modules'

interface Props {
  data: BoosterMilestoneCompletion[]
}

export const BoosterMilestoneCompletionCard = ({ data }: Props) => {
  return (
    <Card className="booster-detail__milestone-completion" title="Milestone Completion">
      <Row gutter={[24, 24]}>
        {data.map((m) => {
          const percent = m.total > 0 ? Math.round((m.completed / m.total) * 100) : 0
          return (
            <Col key={m.label} xs={24} sm={12} lg={6}>
              <div className="booster-detail__milestone-completion-item">
                <div className="booster-detail__milestone-completion-row">
                  <span className="booster-detail__milestone-completion-label">{m.label}</span>
                  <span className="booster-detail__milestone-completion-percent">{percent}%</span>
                </div>
                <Progress percent={percent} size="small" strokeColor="#155dfc" showInfo={false} />
                <div className="booster-detail__milestone-completion-value">
                  {new Intl.NumberFormat('en-US').format(m.completed)} users
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </Card>
  )
}
